import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetContactAlertsQuery = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [API_ROUTES.CONTACT_ALERTS],
    queryFn: () => api.get(API_ROUTES.CONTACT_ALERTS),
  });
  return { data: data?.data?.data ?? [], isLoading, isError, error };
};

export const useCreateContactAlertMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) => api.post(API_ROUTES.CONTACT_ALERTS, data),
      onSuccess: (response) => {
        showToast(
          "success",
          response?.data?.message || "Contact alert created successfully"
        );
      },
      onError: (error) => {
        showToast(
          "error",
          error?.response?.data?.message || "Failed to create contact alert"
        );
      },
      onSettled: () => {
        queryClient.invalidateQueries([API_ROUTES.CONTACT_ALERTS]);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useUpdateContactAlertMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) => api.put(API_ROUTES.CONTACT_ALERTS, data),
      onSuccess: (response) => {
        showToast(
          "success",
          response?.data?.message || "Contact alert updated successfully"
        );
      },
      onError: (error) => {
        showToast(
          "error",
          error?.response?.data?.message || "Failed to update contact alert"
        );
      },
      onSettled: () => {
        queryClient.invalidateQueries([API_ROUTES.CONTACT_ALERTS]);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useDeleteContactAlertMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) => api.delete(API_ROUTES.CONTACT_ALERTS, { data }),
      onSuccess: (response) => {
        showToast(
          "success",
          response?.data?.message || "Contact alert deleted successfully"
        );
      },
      onError: (error) => {
        showToast(
          "error",
          error?.response?.data?.message || "Failed to delete contact alert"
        );
      },
      onSettled: () => {
        queryClient.invalidateQueries([API_ROUTES.CONTACT_ALERTS]);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};
